import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import { showNotification, successNofication } from 'src/shared/components/Notification';
import PollingIntervalConfig from './PollingIntervalConfig';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';


const PollingIntervalConfigIndex = () => {
  useEffect(() => {
    getComServerConfiguration();
  }, [])
  const [data, setData] = useState([]);
  const getComServerConfiguration = async () => {
    try {
  
      const response = await PndRestApi.GetComServerConfiguration();
      if (response.status === 200 && response.data.status === 200) {
        setData(response.data.data);
      } else if (response?.data?.status && response?.data?.status === 204) { //No Record Found
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response?.data?.status}`,
          `Message: ${response?.data?.message}`,
        );
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response?.data?.status}`,
          `Message: ${response?.data?.message}`,
        );
      }

    } catch (error) {
      console.log("Error in getComServerConfiguration", error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        `Message:Something went wrong. Please try again later.`,
      );
    } 
  };
  
  const handleSubmit = async (formValues) => {
    try {  
        const response = await PndRestApi.UpdateComServerConfiguration(formValues);
        if (response.status === 200 && response.data.status === 200) {
            successNofication(
                "theme-light",
                "ltr",
                `SuccessCode: ${response.data.status}`,
                ERROR_MESSAGES.successMessage,
            );
            //setIsRedirect(true);
        } else {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: ${response.data.status}`,
                `Message:${response.data.message}`,
            );
        }
    } catch (error) {
        console.log("error",error);
        showNotification(
            "theme-light",
            "ltr",
            `SuccessCode: 500`,
            ERROR_MESSAGES.tryCatchError,
        );
    }
};

  return (
    <Container>
      <PollingIntervalConfig onSubmit={handleSubmit}  data={data}/>
    </Container>
  );
};

export default PollingIntervalConfigIndex;
